import React from "react";
import { injectIntl } from "react-intl";

declare global {
  interface FormatMessage {
    (
      message: { id: string; defaultMessage: string },
      vars?: Record<string, any>
    ): string;
  }
}

type FormatMessageProp = {
  formatMessage: FormatMessage;
};
export default function withIntl<P extends {}>(
  WrappedComponent: React.ComponentType<P>
): React.ComponentType<Omit<P, keyof FormatMessageProp>> {
  const Wrapped: React.FC<any> = (props: any) => {
    const formatMessage = React.useCallback(
      (message: any, values?: any) => {
        if (props.intl) {
          return props.intl.formatMessage(message, values);
        }

        return message.defaultMessage;
      },
      [props.intl]
    );
    return <WrappedComponent {...props} formatMessage={formatMessage} />;
  };
  const injected = injectIntl(Wrapped);
  injected.displayName = WrappedComponent.displayName || WrappedComponent.name;
  return injected;
}
